import InfoRounded from '@mui/icons-material/InfoRounded';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

type LastSyncErrorDateTimeProps = {
  errorDatetime: string;
};

export const LastSyncErrorDateTime = ({ errorDatetime }: LastSyncErrorDateTimeProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Typography variant="body1" sx={{ whiteSpace: 'nowrap' }}>
        {format(new Date(errorDatetime), 'yyyy-MM-dd HH:mm:ss')}
      </Typography>

      <Tooltip title={t('The last time the error(s) occurred.')} placement="top">
        <IconButton>
          <InfoRounded />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
